import { Outlet } from 'react-router-dom';
import HeaderV2 from '../components/HeaderV2';
import Footer from '../components/Footer';
import SideCart from '../components/SideCart';
import WhatsAppFAB from '../components/WhatsAppFAB';

const LayoutV2 = () => (
  <>
    <HeaderV2 />
    <SideCart />
    <main style={{ paddingTop: '104px' }}>
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFAB />
  </>
);

export default LayoutV2;
